"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _loading = _interopRequireDefault(require("./loading"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var service = _axios["default"].create({
  baseURL: "/"
  //timeout: 10000,
});

// request拦截器
service.interceptors.request.use(function (config) {
  _loading["default"].open();
  return config;
}, function (error) {
  Promise.reject(error);
});
// 响应拦截器
service.interceptors.response.use(function (res) {
  _loading["default"].reduceNum();
  if (res.data.status == "M0401") {
    window.LOWCODE.app.$message({
      type: 'error',
      message: "登录超时，请重新登录"
    });
    window.location.href = "/";
  }
  return res;
}, function (error) {
  _loading["default"].reduceNum();
  window.LOWCODE.app.$message({
    message: '接口连接异常',
    type: 'error',
    duration: 5 * 1000
  });
  console.warn('接口连接异常' + error);
  return Promise.reject(error);
});
var _default = service;
exports["default"] = _default;